/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-destructuring */


import api, {
  partHeader, 
  apiInternal
 } from '../../api.js';

const moment = require('moment');

moment().format();

const state = {
  all: [],
};

const getters = {
  accessById: state => id => state.all.find(access => access.acc_id === id),
  accessByEstaId: state => id => state.all.filter(access => access.esta_id === id),
};

const actions = {
  async getAccessByEstaId({ state, commit }, estaId) {
    const result = await api.post(`${apiInternal}/getListAccess`,{ esta_id: estaId },partHeader);
    if (result) commit('setAccess', { access: result.data, id: estaId });
    return result;
  },
};

const mutations = {
  setAccess(state, { access, id }) {
    access.forEach((newAccess) => {
      newAccess.esta_id = id;
      const index = state.all.findIndex(access => access.acc_id === newAccess.acc_id);
      if (index >= 0) {
        state.all.splice(index, 1, newAccess);
      } else {
        state.all.push(newAccess);
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
